import { useEffect, useState } from "react";
import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { listQcHistoryPage, type QcHistorySession } from "@/lib/manufacturing/qcDashboardClient";
import { splitModelAndSize } from "@/lib/manufacturing/qcModelSize";
import { queueBuilderAssistantSession } from "@/lib/manufacturing/builderAssistantOpenSession";
import { requestWorkspaceMode } from "@/lib/workspaceModeNavigation";
import { QcDashboardFold } from "./QcDashboardFold";

function openSession(sessionId: string) {
  queueBuilderAssistantSession(sessionId);
  requestWorkspaceMode({ mode: "mfgBuilderAssistant" });
}

export function QcDashboardFinalQc({ reloadKey }: { reloadKey: number }) {
  const [rows, setRows] = useState<QcHistorySession[]>([]);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void listQcHistoryPage({ status: "final", page: 0, sort: "newest" }).then((res) => {
      if (cancelled) return;
      if (!res.ok) {
        setError(res.error);
        return;
      }
      setError(null);
      setRows(res.data.sessions);
      setTotal(res.data.total);
    });
    return () => {
      cancelled = true;
    };
  }, [reloadKey]);

  return (
    <QcDashboardFold title="Awaiting final QC" defaultOpen>
      <p className="text-sm text-gray-900 dark:text-zinc-100">
        Inspections with nothing left to fix. Final QC can fail an item again or pass the building.
      </p>
      {error ? <p className="text-sm text-red-700 dark:text-red-300">{error}</p> : null}
      {rows.length === 0 && !error ? <p className="text-sm text-gray-900 dark:text-zinc-100">Nothing is waiting on final QC.</p> : null}
      {total > rows.length ? (
        <p className="text-sm text-gray-900 dark:text-zinc-100">
          Showing the newest {rows.length} of {total}. The rest are in Builder Assistant history.
        </p>
      ) : null}
      <ul className="space-y-2">
        {rows.map((row) => {
          const split = splitModelAndSize(row.model_hint);
          return (
            <li key={row.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 dark:border-zinc-700 dark:text-zinc-100">
              <span className="min-w-0">
                <span className="font-medium">{row.serial_text.trim() || "No serial"}</span>
                {split.model ? <span> · {split.model}</span> : null}
                {split.size ? <span> · {split.size}</span> : null}
              </span>
              <button type="button" className={ghostBtnClass} onClick={() => openSession(row.id)}>
                Open
              </button>
            </li>
          );
        })}
      </ul>
    </QcDashboardFold>
  );
}
